import { render, staticRenderFns } from "./business_order_detail.vue?vue&type=template&id=d87939c0&scoped=true"
import script from "./business_order_detail.vue?vue&type=script&lang=ts"
export * from "./business_order_detail.vue?vue&type=script&lang=ts"
import style0 from "./business_order_detail.vue?vue&type=style&index=0&id=d87939c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87939c0",
  null
  
)

export default component.exports